import { render, staticRenderFns } from "./progress.vue?vue&type=template&id=ae4e7722&"
import script from "./progress.vue?vue&type=script&lang=js&"
export * from "./progress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae4e7722')) {
      api.createRecord('ae4e7722', component.options)
    } else {
      api.reload('ae4e7722', component.options)
    }
    module.hot.accept("./progress.vue?vue&type=template&id=ae4e7722&", function () {
      api.rerender('ae4e7722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/progress/progress.vue"
export default component.exports